'use client';

import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { HttpClient } from '@/api/HttpClient';

/**
 * Wires HttpClient session recovery for 401 handling.
 * App JWT bootstrap runs in MsalProvider via ensureAppAuthReady (after MSAL is available).
 */
export function AuthInitializer() {
  useEffect(() => {
    HttpClient.setSessionRecovery(() => useAuthStore.getState().attemptSessionRecovery());
    return () => HttpClient.setSessionRecovery(null);
  }, []);

  return null;
}
